import React, { ReactElement } from 'react';
import {
  TagLabelColor,
  TagLabelContainer,
  TagLabelIconPosition,
  useTranslations,
} from '@lerna-core';
import { SubscriptionTagContainerProps } from './subscriptionTag.model';
import { SubscriptionTagContainerStyled } from './subscriptionTag.styled';

export const SubscriptionTagContainer = ({
  size,
}: SubscriptionTagContainerProps): ReactElement => {
  const translations = useTranslations();

  return (
    <SubscriptionTagContainerStyled>
      <TagLabelContainer
        noWrap={false}
        label={translations?.courses_subscription_free}
        color={TagLabelColor.subscription}
        size={size}
        iconPosition={TagLabelIconPosition.right}
        borderRadius={100}
      />
    </SubscriptionTagContainerStyled>
  );
};
